import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { MOBILE_CTA } from "@/constants/testIds";
import { usePricing, fmtPrice } from "@/hooks/usePricing";

export default function MobileCTABar() {
  const [visible, setVisible] = useState(false);
  const pricing = usePricing();

  useEffect(() => {
    const checkout = document.getElementById("checkout");
    const onScroll = () => {
      const pastHero = window.scrollY > 480;
      let checkoutInView = false;
      if (checkout) {
        const r = checkout.getBoundingClientRect();
        checkoutInView = r.top < window.innerHeight && r.bottom > 0;
      }
      setVisible(pastHero && !checkoutInView);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid={MOBILE_CTA.bar}
      className={`lg:hidden fixed inset-x-0 bottom-0 z-50 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="mx-3 mb-3 rounded-2xl bg-white shadow-[0_-4px_30px_rgb(0,0,0,0.12)] border border-[#5982c5]/15 flex items-center gap-3 p-2.5">
        <div className="pl-2">
          <p className="text-[11px] font-semibold text-[#9ca3af] leading-none">ComprehensionUp</p>
          <p className="font-heading font-extrabold text-lg text-[#1f2937] leading-tight">
            {fmtPrice(pricing.main.price)} {pricing.main.compare_at && <span className="text-sm font-semibold text-[#64748b] line-through">{fmtPrice(pricing.main.compare_at)}</span>}
          </p>
        </div>
        <button
          data-testid={MOBILE_CTA.button}
          onClick={() => document.getElementById("checkout")?.scrollIntoView({ behavior: "smooth" })}
          className="ml-auto flex-1 max-w-[62%] bg-[#f0d203] text-[#1a1a1a] active:scale-[0.98] transition-transform font-bold px-4 py-3.5 rounded-full flex items-center justify-center gap-2"
        >
          Acquista ora <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
}
